import { render, staticRenderFns } from "./ContentPage.vue?vue&type=template&id=a9b8c9e2&scoped=true"
import script from "./ContentPage.vue?vue&type=script&lang=js"
export * from "./ContentPage.vue?vue&type=script&lang=js"
import style0 from "./ContentPage.vue?vue&type=style&index=0&id=a9b8c9e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b8c9e2",
  null
  
)

export default component.exports